import { HamburgerCheckIcon } from './HamburgerCheckIcon';

/**
 * author: Colton Wiscombe
 * id 15C2280B-B4C8-436A-8D57-80FFD3C4FB62
 * name hamburger-check
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hamburger-check.svg
 * tags
 * - Food / Drink 
 */
export const BurgerCheckIcon = HamburgerCheckIcon;
export default BurgerCheckIcon